<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <silence-all-alerts
          :alert-sources="alertSources"
          :alert-metrics="alertMetrics"
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SilenceAllAlerts from './Overlay/SilenceAllAlerts.vue';

export default {
  components: {
    SilenceAllAlerts,
  },
  props: {
    alertSources: {
      type: Array,
      default() {
        return [];
      },
    },
    alertMetrics: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {},
};
</script>

<style></style>
